import React, { useState, useEffect} from 'react';
import { useLanguage } from '../../../context/LanguageContext';
import { useNavigate, useLocation } from 'react-router-dom';
import { fetchUser } from '../../../api/api_users';

function AddHubFast() {
  const { translations } = useLanguage();
  const navigate = useNavigate();
  const location = useLocation();
  const [ssid, setSSID] = useState('');
  const [password, setPassword] = useState('');
  const [device, setDevice] = useState(null);

  useEffect(() => {
    if (location.state) {
      setSSID(location.state.ssid || '');
      setPassword(location.state.password || '');
    }
  }, [location.state]);

  const handleBack = () => {
    navigate(-1);
  };

  const handleQRScanner = () => {
    navigate('qrScanner');
  };

  const connectToDevice = async () => {
    try {
      const device = await navigator.bluetooth.requestDevice({
        filters: [
          { namePrefix: 'IS' },
          { namePrefix: 'NIS' }
        ],
        optionalServices: ['9d18c4a5-3b7d-4c98-9237-8f4e3e85c289']
      });
      await device.gatt.connect();
      setDevice(device);
      console.log('Connected to device', device.name);
    } catch (error) {
      console.error('Error connecting to Bluetooth device!', error);
    }
  };

  const sendWifiCredentials = async () => {
    if (!device) {
      alert(translations.no_device);
      return;
    }

    if (!ssid || !password) {
      alert(translations.no_ssid_pass);
      return;
    }

    try {
      const user = await fetchUser()
      const service = await device.gatt.getPrimaryService('9d18c4a5-3b7d-4c98-9237-8f4e3e85c289');
      const characteristic = await service.getCharacteristic('e217a8b1-3e48-4a70-9f82-2c9d14e4d3d2');
      const encoder = new TextEncoder('utf-8');
      const message = `newWifiConfig|${ssid}|${password}|${user.data.id}`;
      const data = encoder.encode(message);
      await characteristic.writeValue(data);
      console.log('Credentials sent');
      await device.gatt.disconnect();
      console.log('Disconnected from device');
      setDevice(null);
    } catch (error) {
      console.error('Error sending credentials to Bluetooth device!', error);
    }
    navigate('link');
  };

  return (
    <div className="sm-page">
      <div className="sm-container">
        <div className="header">
          <button onClick={handleBack} className="back-button">&#8592;</button>
          <h1>{translations.device_setup}</h1>
        </div>
        <div className="content">
          <button onClick={connectToDevice} className="general-button fastSettings-button mid-button">
            {translations.select_device}
          </button>
        </div>
        <div className="sm-space-info2">
          <div className="content">
            <input
              type="text"
              className="general-input"
              placeholder={translations.ssid}
              value={ssid}
              onChange={(e) => setSSID(e.target.value)}
            />
            <input
              type="password"
              className="general-input"
              placeholder={translations.wifi_pass}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
              <button onClick={handleQRScanner} className="general-button fastSettings-button mid-button">
                {translations.scan_qr}
              </button>
            </div>
            <div className="content">
              <button onClick={sendWifiCredentials} className="general-button mid-button">
                {translations.send_credentials}
              </button>
            </div>
          </div>
      </div>
    </div>
  );
}

export default AddHubFast;
